import React from 'react';
import ai1 from '../../assets/ai1.png';
import ai2 from '../../assets/ai2.jpg';
import ai3 from '../../assets/ai3.jpg';
import ai4 from '../../assets/ai4.png';
import ai5 from '../../assets/ai5.jpg';


const A1 = () => {
  return (
    <div className='page1'>
      <div className='overall'>
        <h2 className='heading'>தாய்பால் ஊட்டுதல்</h2>
        <h3 className='subheading'>தாய்ப்பாலூட்டலில் ஏற்படும் பிரச்சனைகள்</h3>

      </div>
      <div className='answer'>
        <h3 style={{ color: '#BB0297' }}>தாய்ப்பால் கொடுக்கும்போது ஏற்படும் பிரச்சனைகள் ?</h3>
        <br />
        <img src={ai1} className='image' alt="" />
        <br />
        <h3 style={{ color: '#BB0297' }}>மார்பகங்களில் பால் கட்டுவது (Breast Engorgement):</h3><br></br>

        <p>தாய்ப்பால் கொடுப்பது தாமதமானாலோ, போதுமான அளவு தாய்ப்பால் கொடுக்காததாலோ, தாய்ப்பால் கொடுக்கும்போது தவறுதலான நிலை மற்றும் இணைப்பு இருந்தாலோ பால்சுரப்பிகளில் அதிக அளவு தாய்ப்பால் சேர்ந்து கொண்டு, மார்பகங்களில் பால் கட்டிக்கொள்கிறது. மார்பகங்களில் இவ்வாறு பால் கட்டிக்கொள்ளும்போது, மார்பகங்களில் வீக்கம் மற்றும் மிகுந்த வலி ஏற்படுகிறது.</p>
        <br></br>
        <br></br>
        <h4>பால் கட்டிக்கொண்டால் சரி செய்யும் முறை:-</h4><br></br>

        <ul>
          <li>மார்பகங்களில் பால் கட்டிக்கொண்டால், வெந்நீர் ஒத்தடம் கொடுக்கலாம். இது, பால் வெளியேற்றுதலை அதிகரிக்கும்.</li>
          <li>2 3 மணிநேரத்துக்கு ஒவ்வொரு முறையும் தாய்ப்பால் கொடுக்க வேண்டும்.</li>
          <li>ஐஸ் ஒத்தடம் கொடுக்கும்போது, மார்பக வீக்கம் மற்றும் வலி குறையும்.</li>
          <li>ஒரு மார்பகத்தில் உள்ள தாய்ப்பாலை முழுமையாகக் கொடுத்து முடித்த பிறகுதான், அடுத்த மார்பகத்தில் தாய்ப்பால் கொடுக்கத் தொடங்க வேண்டும். மாறாக ஒரு மார்பகத்தில் உள்ள தாய்ப்பாலை முற்றிலும் தராத பட்சத்தில், மார்பகத்தில் மேலும் தாய்ப்பால் கட்டிக்கொள்ளும்.</li>
          <li>மார்பகங்களை மசாஜ் செய்யும்போது வீக்கம் மற்றும் வலி குறையும்.</li>
          <li>மார்பக வலி அதிகமாக இருந்தால், மருத்துவர் அறிவுறுத்திய வலி நிவாரணிகளை எடுத்துக்கொள்ளலாம்.</li>
          <li>தாய்ப்பால் கொடுக்க முடியவில்லையென்றால், விரல்களைக் கொண்டோ, மார்பக பம்பை (Breast Pump) கொண்டோ தாய்ப்பாலை வெளியேற்ற வேண்டும்.</li>
          <li>தாய்ப்பால் கொடுக்கும்போது ஒவ்வொரு முறையும் நான்கு நிலைகளை உறுதி செய்வதன் மூலம், மார்பகங்களில் பால் கட்டும் பிரச்சனை வராமல் தடுக்க முடியும்.</li>
        </ul>

        <br></br><h3 style={{ color: '#BB0297' }}>மார்பகக் கட்டி(breast abscess)</h3>
        <img src={ai2} className='image' alt="" />


        மார்பகங்களில் பால் கட்டுவது, பால் குழாய் அடைப்பு, மார்பக முலைக்காம்பில் வெடிப்பு, முலையழற்சி போன்றவற்றுக்கு ஆரம்ப நிலையிலேயே சிகிச்சை அளிக்கப்படவில்லை என்றால், மார்பகக் கட்டி ஏற்படலாம்.
        மார்பகக் கட்டி ஏற்பட்டால், காய்ச்சல் மற்றும் மார்பகத்தில் வீக்கம், வலி, சூடாக இருத்தல், சிவந்துபோதல் போன்ற அறிகுறிகள் ஏற்படும். மார்பகக் கட்டி ஏற்பட்டால், மருத்துவர் அறிவுரைப்படி, சிகிச்சை எடுத்து கொள்ள வேண்டும்.

        <br></br>
        <br></br>
        <h3 style={{ color: '#BB0297' }}>தலைகீழான முலைக்காம்புகள் (Inverted nipples):</h3><br></br>
        <img src={ai3} className='image' alt="" />

        தலைகீழான முலைக்காம்புகள் (Inverted nipples) மற்றும் உள்ளிழுக்கப்பட்ட முலைக்காம்புகள் (Retracted nipples) தாய்ப்பால் கொடுப்பதை கடினப்படுத்திவிடும். தாய்ப்பால் கொடுக்கும்போது, முலைக்காம்பு மற்றும் அதைச் சுற்றியுள்ள முகட்டு வட்டத்தின் (Areola) பெரும்பாலான பகுதி குழந்தையின் வாயினுள் இருக்க வேண்டும்.

        <br></br>
        <br></br>
        <br></br>
        <h3>தலைகீழான முலைக்காம்பை சரிசெய்யும் முறை:</h3>
        <br></br>
        <h4>சிரிஞ்ச் கொண்டு முலைக்காம்பை வெளியே இழுத்தல்:</h4>
        <br></br>
        <br></br>

        <img src={ai4} className='image' alt="" />
        தலைகீழான முலைக்காம்புகள் அல்லது உள்ளிழுக்கப்பட்ட முலைக்காம்புகள் இருந்தால், குழந்தையால் சரிவர தாய்ப்பாலை எடுத்துக்கொள்ள முடியாது. எனவே, சரிவர முலைக்காம்பில் புண்கூட ஏற்படலாம். தாய்ப்பால் கொடுப்பதற்கு முன் ஒவ்வொரு முறையும் சிரிஞ்ச் (Syringe) மூலம் முலைக்காம்புகளை வெளியே இழுப்பதன் மூலம் இதனை சரி செய்ய முடியும்.
        <br></br>
        <br></br>


        <h3 style={{ color: '#BB0297' }}>முலைக்காம்பில் புண் (Sore nipple):</h3>

        <img src={ai5} className='image' alt="" />

        தாய்ப்பால் கொடுக்கும்போது, முலைக்காம்பு மற்றும் அதைச் சுற்றியுள்ள முகட்டு வட்டத்தின் (Areola) பெரும்பாலான பகுதி குழந்தையின் வாயினுள் இருக்க வேண்டும். மாறாக முலைக்காம்பு மட்டுமே குழந்தையின் வாயினுள் இருந்தால், குழந்தை சப்பும்போது தாய்ப்பால் வெளிப்படாது. எனவே, குழந்தை, தீவிரமாக முலைக்காம்பை சப்பவும் கடிக்கவும் தொடங்கும். இதனால் முலைக்காம்பில் புண் ஏற்படலாம். சோப்பு மற்றும் தண்ணீர் கொண்டு அடிக்கடி மார்பகங்களை சுத்தப்படுத்துவதாலும், குழந்தை தாய்ப்பால் குடித்துக் கொண்டிருக்கும்போதே நீக்குவதாலும்கூட முலைக்காம்பில் புண் ஏற்படலாம் மார்பகத்திலிருந்து
        <br></br>
        <br></br>
        <h3>முலைகாம்பு புண்ணை சரி செய்யும் முறை:-</h3>
        <br></br>
        <ul>
          <li>தாய்ப்பால் கொடுக்கும்போது ஒவ்வொரு முறையும் நான்கு நிலைகள் மற்றும் நான்கு இணைப்பு படிகளை (Four Steps of Positioning and Attachment) ល ល தடுக்க முடியும்.</li>
          <li>தாய்ப்பால் கொடுத்து முடிக்கும்போது இறுதியில் சுரக்கும் தாய்ப்பாலை (Hindmilk) முலைக்காம்பின் மீது இட்டு வர, புண் சரியாகும்.</li>
          <li>தாய்ப்பால் கொடுப்பதற்கு முன்பும், கொடுத்ததற்கு பின்பும் அடிக்கடி முலைக்காம்பை சுத்தப்படுத்த வேண்டாம். குளிக்கும்போது மட்டும் ஒரேயொரு முறை மார்பகம் மற்றும் முலைக்காம்பை சுத்தப்படுத்திக்கொள்ளலாம். முலைக்காம்பின் புண் மீது எவ்வித க்ரிமோ களிம்போ தடவத்தேவையில்லை.</li>

        </ul>
      </div>

    </div>
  );
};

export default A1
